/**
 * Status mapping utility to convert frontend status values to backend-allowed values
 * Backend only accepts: ['available', 'busy', 'away', 'offline']
 */

export const mapFrontendStatusToBackend = (frontendStatus) => {
  // Normalize the status to lowercase for consistent comparison
  const normalizedStatus = (frontendStatus || "").toLowerCase();

  // Map frontend statuses to backend-allowed values
  const statusMap = {
    connecting: "busy",
    "on call": "busy",
    "wrap-up": "busy",
    available: "available",
    break: "away",
    away: "away",
    offline: "offline",
    busy: "busy",
  };

  // Return the mapped status or default to 'available' if not found
  return statusMap[normalizedStatus] || "available";
};

/**
 * Reverse mapping - convert backend status to frontend display status
 * This can be used for displaying the correct status in the UI
 */
export const mapBackendStatusToFrontend = (backendStatus, callState = null) => {
  // If we have specific call state information, use it for more accurate status
  if (callState) {
    if (callState.isConnecting) return "Connecting";
    if (callState.isOnCall) return "On Call";
    if (callState.isWrapUp) return "Wrap-up";
  }

  // Otherwise, map backend status to frontend display
  const statusMap = {
    available: "Available",
    busy: "Busy",
    away: "Break",
    offline: "Offline",
  };

  return statusMap[backendStatus] || "Available";
};
